import type { InfringementExportRow } from 'src/context/api/brandInfringement/api';

const CSV_COLUMNS: [string, (r: InfringementExportRow) => string | null][] = [
    ['Region', (r) => r.region_name],
    ['Domain', (r) => r.domain_name],
    ['Trademark Report URL', (r) => r.url],
    ['Trademark Report Referral URL', (r) => r.url_referral],
    ['Trademark Report Title', (r) => r.title],
    ['Trademark Report Description', (r) => r.description],
];

const escapeCsv = (value: string | null): string => {
    let v = value ?? '';
    if (/^[=+\-@\t\r]/.test(v)) v = `'${v}`;
    return /[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
};

// An ad is written once: the export rows hold one entry per sighting of it (per day and per
// search term), which only differ by their SERP, not a column. A Set keeps the first-seen order.
export const buildCsv = (rows: InfringementExportRow[]): string => {
    const lines = rows.map((row) => CSV_COLUMNS.map(([, get]) => escapeCsv(get(row))).join(','));
    return [CSV_COLUMNS.map(([name]) => name).join(','), ...Array.from(new Set(lines))].join('\n');
};

export const csvFilename = (workspaceName: string, domain?: string) =>
    domain
        ? `${workspaceName} - Trademark report for screenshot - ${domain}.csv`
        : `${workspaceName} - Trademark report.csv`;

const UTF8_BOM = '\uFEFF';

export const downloadTextFile = (filename: string, content: string, mime: string) => {
    const blob = new Blob([`${UTF8_BOM}${content}`], { type: `${mime};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
